<!-- BL Amend Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="onSearch()"
          class="form-control form-control-solid w-250px ps-13"
          placeholder="Search..." />
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
        <!-- Copy ISL# Button - Show when items are selected -->
        <button
          *ngIf="selectedItems.size > 0"
          type="button"
          class="btn btn-sm btn-success me-3"
          (click)="copySelectedISL()">
          <i class="ki-duotone ki-copy fs-4 me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Copy ISL# ({{ getSelectedCount() }})
        </button>
        <!-- Save Changes Button -->
        <button
          *ngIf="hasChanges"
          type="button"
          class="btn btn-sm btn-primary me-3"
          [disabled]="isSaving"
          (click)="onSave()">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isSaving" class="ki-duotone ki-check fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Save Changes
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3 text-muted">Loading BL Amend data...</p>
    </div>

    <!-- No Data State -->
    <div *ngIf="!isLoading && blAmendData.length === 0" class="text-center py-10">
      <div class="text-gray-400 fs-1 mb-3">
        <i class="ki-duotone ki-document fs-3x">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <h3 class="text-gray-800 fs-2 fw-bold mb-3">No BL Amend data found</h3>
      <p class="text-gray-400 fs-6 mb-0">Try adjusting your search criteria</p>
    </div>

    <!-- BL Amend Table -->
    <div *ngIf="!isLoading && blAmendData.length > 0" class="bl-amend-table-container">
      <div class="table-responsive">
        <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 bl-amend-table">
          <thead>
            <tr class="fw-bold text-muted bg-light">
              <!-- Sticky Stock Number Column with Select All Checkbox -->
              <th class="sticky-column min-w-150px">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input class="form-check-input"
                           type="checkbox"
                           [checked]="isAllSelected()"
                           [indeterminate]="isIndeterminate()"
                           (change)="onSelectAll($event)" />
                  </div>
                  Stock No.
                </div>
              </th>
              <!-- Scrollable Columns -->
              <th class="min-w-80px text-center">Price Sheet</th>
              <th class="min-w-80px text-center">AR</th>
              <th class="min-w-80px text-center">Docs</th>
              <th class="min-w-200px">Customer/Notify Party</th>
              <th class="min-w-150px">Destination Port</th>
              <th class="min-w-150px">Destination Country</th>
              <th class="min-w-120px">Invoice Date</th>
              <th class="min-w-120px">Make</th>
              <th class="min-w-150px">Model</th>
              <th class="min-w-150px">Chassis #</th>
              <th class="min-w-120px">Ship Name</th>
              <th class="min-w-120px">Carrier Name</th>
              <th class="min-w-120px">Sailing Date</th>
              <th class="min-w-120px">Sailing Port</th>
              <th class="min-w-120px">Arrival Date</th>
              <th class="min-w-120px">BL Amend 1</th>
              <th class="min-w-120px">BL Amend 2</th>
              <th class="min-w-120px">BL Amend 3</th>
              <th class="min-w-150px">BL Memo</th>
              <th class="min-w-120px">Created By</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of blAmendData; trackBy: trackByFn" class="bl-amend-row">
              <!-- Sticky Stock Number Column with Checkbox -->
              <td class="sticky-column">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input class="form-check-input"
                           type="checkbox"
                           [value]="item._id"
                           [checked]="isItemSelected(item._id)"
                           (change)="onItemSelect(item._id, $event)" />
                  </div>
                  <span class="fw-bold text-primary">{{ getDisplayValue(item.order?.vehicles[0]?.car_no) }}</span>
                </div>
              </td>

              <!-- Price Sheet - Icon -->
              <td class="text-center">
                <a href="javascript:;" (click)="onPriceSheetClick(item)">
                  <i class="ki-duotone ki-dollar fs-2 text-gray-800 text-hover-primary cursor-pointer">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                  </i>
                </a>
              </td>

              <!-- AR - Checkbox -->
              <td class="text-center">
                <div class="form-check form-check-custom form-check-solid justify-content-center">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [ngModel]="getFormValue(item._id, 'ar')"
                    (ngModelChange)="setFormValue(item._id, 'ar', $event)" />
                </div>
              </td>

              <!-- Docs - Icon -->
              <td class="text-center">
                <a href="javascript:;" (click)="onDocsClick(item)">
                  <i class="ki-duotone ki-document fs-2 text-gray-800 text-hover-primary cursor-pointer">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </a>
              </td>

              <!-- Customer/Notify Party -->
              <td class="text-nowrap">
                {{ getDisplayValue(item.order?.buyer_consignee_name) }} / {{ getDisplayValue(item.order?.same_as_consignee ? item.order?.buyer_consignee_name : item.order?.notify_party_name) }}
              </td>

              <!-- Destination Port -->
              <td>{{ getDisplayValue(item.order?.to_port) }}</td>

              <!-- Destination Country -->
              <td>{{ getDisplayValue(item.order?.to_country) }}</td>

              <!-- Invoice Date -->
              <td>{{ getDisplayValue(item.invoice_date) }}</td>

              <!-- Make -->
              <td>{{ getDisplayValue(item.order?.vehicles[0]?.make) }}</td>

              <!-- Model -->
              <td>{{ getDisplayValue(item.order?.vehicles[0]?.name) }}</td>

              <!-- Chassis # -->
              <td class="text-nowrap">{{ getDisplayValue(item.order?.vehicles[0]?.vin_no) }}</td>

              <!-- Ship Name -->
              <td>{{ getDisplayValue(item.ship_name) }}</td>

              <!-- Carrier Name -->
              <td>{{ getDisplayValue(item.carrier_name) }}</td>

              <!-- Sailing Date -->
              <td>{{ getDisplayValue(item.sailing_date) }}</td>

              <!-- Sailing Port -->
              <td>{{ getDisplayValue(item.sailing_port) }}</td>

              <!-- Arrival Date -->
              <td>{{ getDisplayValue(item.arrival_date) }}</td>

              <!-- BL Amend 1 -->
              <td class="text-center">
                <span *ngIf="item.bl_amendment_1"
                      class="badge badge-success cursor-pointer"
                      (click)="openViewBlFormModal(item, 1)">Yes</span>
                <span *ngIf="!item.bl_amendment_1">-</span>
              </td>

              <!-- BL Amend 2 -->
              <td class="text-center">
                <span *ngIf="item.bl_amendment_2"
                      class="badge badge-success cursor-pointer"
                      (click)="openViewBlFormModal(item, 2)">Yes</span>
                <span *ngIf="!item.bl_amendment_2">-</span>
              </td>

              <!-- BL Amend 3 -->
              <td class="text-center">
                <span *ngIf="item.bl_amendment_3"
                      class="badge badge-success cursor-pointer"
                      (click)="openViewBlFormModal(item, 3)">Yes</span>
                <span *ngIf="!item.bl_amendment_3">-</span>
              </td>

              <!-- BL Memo - Text Input -->
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getFormValue(item._id, 'bl_memo')"
                  (ngModelChange)="setFormValue(item._id, 'bl_memo', $event)"
                  placeholder="Enter memo" />
              </td>

              <!-- Created By -->
              <td>{{ getDisplayValue(item.created_by?.name) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination -->
    <app-pagination
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>

<!-- View BL Form Modal -->
<app-view-bl-form #viewBlFormModal></app-view-bl-form>
